import type { GetAdminDashboardStats200 } from '@api/models';

import { ApiClient } from '@website/lib/api';

export type AdminDashboardStatsResponse = GetAdminDashboardStats200;

export interface RecentActivityItem {
  type: 'user_signup' | 'booking' | 'professional_verified' | 'activity_created';
  entityId: string;
  entityName: string;
  createdAt: number;
}

export interface AdminDashboardStats {
  totalUsers: number;
  totalProfessionals: number;
  pendingVerifications: number;
  totalActivities: number;
  pendingActivities: number;
  activeBookings: number;
  pendingDisputes: number;
  /** New Hubs plus published Hubs with changes, waiting for review. */
  pendingHubs: number;
  recentActivity: RecentActivityItem[];
}

export async function getAdminDashboardStats(): Promise<AdminDashboardStats> {
  const response = await ApiClient.getAdminDashboardStats();
  return response as AdminDashboardStats;
}
